export default {"src":"/_next/static/media/number3--salmon.3ea9bfb7.svg","height":45,"width":29,"blurWidth":0,"blurHeight":0};